<div class="w-100 navbar">
  <div
    *ngFor="let item of navItems"
    class="navbar-icon"
    [class.active]="checkUrl(item.routerLink)"
    (click)="router.navigate([item.routerLink])"
    [ngSwitch]="item.title"
  >
    <div *ngIf="item.title == nonFeatureMenuItems.Home.toLocaleLowerCase()">
      <ng-container *ngTemplateOutlet="homeIcon"></ng-container>
    </div>
    <div *ngIf="item.title == 'profile'">
      <ng-container *ngTemplateOutlet="profileIcon"></ng-container>
    </div>
    <div *ngIf="item.title == tenantFeatures.Sprints.toLocaleLowerCase()">
      <ng-container *ngTemplateOutlet="sprintIcon"></ng-container>
    </div>
    <div *ngIf="item.title == tenantFeatures.ToolBox.toLocaleLowerCase()">
      <ng-container *ngTemplateOutlet="toolboxIcon"></ng-container>
    </div>
    <div *ngIf="item.title == tenantFeatures.PersonalPlan.toLocaleLowerCase()">
      <ng-container *ngTemplateOutlet="personalPlanIcon"></ng-container>
    </div>
    <div
      *ngIf="
        item.title == nonFeatureMenuItems.Notifications.toLocaleLowerCase()
      "
    >
      <ng-container *ngTemplateOutlet="notificationsIcon"></ng-container>
    </div>
  </div>
</div>

<ng-template #homeIcon>
  <svg viewBox="0 0 18 18">
    <g>
      <line
        x1="9"
        y1="16"
        x2="9"
        y2="12.75"
        fill="none"
        stroke="#2121217f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        data-color="color-2"
      ></line>
      <path
        d="M3.145,6.2l5.25-3.99c.358-.272,.853-.272,1.21,0l5.25,3.99c.249,.189,.395,.484,.395,.796v7.254c0,1.105-.895,2-2,2H4.75c-1.105,0-2-.895-2-2V6.996c0-.313,.146-.607,.395-.796Z"
        fill="none"
        stroke="#2121217f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      ></path>
    </g>
  </svg>
</ng-template>

<ng-template #profileIcon>
  <svg viewBox="0 0 20 20">
    <title>Profle</title>

    <circle
      cx="10"
      cy="6"
      r="3"
      fill="none"
      stroke="#2121217f"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      data-color="color-2"
    ></circle>
    <path
      d="m4,15.393c1.225-2.033,3.454-3.393,6-3.393s4.775,1.36,6,3.393"
      fill="none"
      stroke="#2121217f"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    ></path>
  </svg>
</ng-template>

<ng-template #sprintIcon>
  <svg viewBox="0 0 20 23" fill="none">
    <path
      d="M10.9999 1.5625L2.09332 12.2504C1.74451 12.6689 1.57011 12.8782 1.56744 13.055C1.56512 13.2086 1.63359 13.3548 1.75312 13.4514C1.89061 13.5625 2.16304 13.5625 2.7079 13.5625H9.99986L8.99986 21.5625L17.9064 10.8746C18.2552 10.4561 18.4296 10.2468 18.4323 10.07C18.4346 9.91638 18.3661 9.7702 18.2466 9.67361C18.1091 9.5625 17.8367 9.5625 17.2918 9.5625H9.99986L10.9999 1.5625Z"
      stroke="#2121217f"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</ng-template>

<ng-template #toolboxIcon>
  <svg viewBox="0 0 44 44" fill="none">
    <path
      d="M10 10L19 19M10 10H4L2 4L4 2L10 4V10ZM36.518 3.48203L31.2627 8.73726C30.4707 9.52929 30.0747 9.92531 29.9263 10.382C29.7958 10.7837 29.7958 11.2163 29.9263 11.618C30.0747 12.0747 30.4707 12.4707 31.2627 13.2627L31.7373 13.7373C32.5293 14.5293 32.9253 14.9253 33.382 15.0737C33.7837 15.2042 34.2163 15.2042 34.618 15.0737C35.0747 14.9253 35.4707 14.5293 36.2627 13.7373L41.1786 8.82143C41.708 10.1098 42 11.5208 42 13C42 19.0751 37.0751 24 31 24C30.2676 24 29.5519 23.9284 28.8595 23.7919C27.8872 23.6001 27.4011 23.5042 27.1064 23.5336C26.7931 23.5648 26.6386 23.6118 26.361 23.7604C26.0999 23.9001 25.8379 24.1621 25.3141 24.6859L11 39C9.34315 40.6568 6.65686 40.6568 5 39C3.34315 37.3431 3.34315 34.6568 5 33L19.3141 18.6859C19.8379 18.1621 20.0999 17.9001 20.2396 17.639C20.3882 17.3614 20.4352 17.2069 20.4664 16.8936C20.4958 16.5989 20.3999 16.1128 20.2081 15.1405C20.0716 14.4481 20 13.7324 20 13C20 6.92487 24.9249 2 31 2C33.011 2 34.896 2.53965 36.518 3.48203ZM22.0001 27.9999L33 38.9998C34.6568 40.6566 37.3431 40.6566 39 38.9998C40.6568 37.3429 40.6568 34.6566 39 32.9998L29.9506 23.9506C29.31 23.89 28.6854 23.7744 28.0816 23.6087C27.3034 23.3951 26.4499 23.5501 25.8793 24.1207L22.0001 27.9999Z"
      stroke="#2121217f"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</ng-template>

<ng-template #personalPlanIcon>
  <svg viewBox="0 0 34 34" fill="none">
    <path
      d="M12.5 17L15.5 20L22.25 13.25M25.8518 6.49776C26.1606 7.2448 26.7535 7.8386 27.5001 8.14861L30.1179 9.23297C30.8649 9.54242 31.4585 10.136 31.7679 10.8831C32.0774 11.6302 32.0774 12.4696 31.7679 13.2167L30.6844 15.8327C30.3748 16.5801 30.3744 17.4204 30.6854 18.1675L31.767 20.7827C31.9204 21.1527 31.9994 21.5494 31.9995 21.9499C31.9995 22.3505 31.9207 22.7471 31.7674 23.1172C31.6141 23.4873 31.3894 23.8235 31.1061 24.1067C30.8228 24.3899 30.4865 24.6145 30.1164 24.7677L27.5005 25.8513C26.7535 26.1602 26.1597 26.7531 25.8497 27.4997L24.7654 30.1175C24.456 30.8646 23.8624 31.4582 23.1154 31.7677C22.3683 32.0771 21.5289 32.0771 20.7818 31.7677L18.1659 30.6841C17.4188 30.3754 16.5797 30.376 15.8331 30.6858L13.2153 31.7686C12.4687 32.0774 11.63 32.0771 10.8836 31.7679C10.1371 31.4587 9.54388 30.8658 9.23422 30.1195L8.14958 27.5009C7.8407 26.7538 7.24782 26.1601 6.50127 25.85L3.8835 24.7657C3.13675 24.4564 2.54338 23.8632 2.23382 23.1165C1.92426 22.3698 1.92384 21.5308 2.23266 20.7838L3.3162 18.1678C3.62488 17.4207 3.62425 16.5816 3.31444 15.8349L2.23246 13.2152C2.07905 12.8451 2.00006 12.4485 2 12.0479C1.99994 11.6474 2.0788 11.2507 2.23208 10.8806C2.38537 10.5106 2.61007 10.1743 2.89335 9.89113C3.17663 9.60793 3.51294 9.38333 3.88305 9.23016L6.49895 8.14658C7.24531 7.83796 7.83873 7.2458 8.14895 6.50008L9.23327 3.88221C9.54272 3.13512 10.1363 2.54155 10.8833 2.23209C11.6304 1.92264 12.4698 1.92264 13.2169 2.23209L15.8328 3.31567C16.5799 3.62437 17.419 3.62374 18.1656 3.31392L20.7845 2.23377C21.5314 1.92449 22.3706 1.92455 23.1176 2.23395C23.8645 2.54335 24.458 3.13674 24.7675 3.88365L25.8521 6.50229L25.8518 6.49776Z"
      stroke="#2121217f"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</ng-template>

<ng-template #notificationsIcon>
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M13.744 2.63358L21.272 7.52679C21.538 7.69969 21.671 7.78615 21.7674 7.90146C21.8527 8.00354 21.9167 8.12162 21.9558 8.24877C22 8.39241 22 8.55104 22 8.8683V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V8.8683C2 8.55104 2 8.39241 2.04417 8.24877C2.08327 8.12162 2.14735 8.00354 2.23265 7.90146C2.32901 7.78615 2.46201 7.69969 2.72802 7.52679L10.256 2.63358M13.744 2.63358C13.1127 2.22327 12.7971 2.01812 12.457 1.93829C12.1564 1.86774 11.8436 1.86774 11.543 1.93829C11.2029 2.01812 10.8873 2.22327 10.256 2.63358M13.744 2.63358L19.9361 6.65849C20.624 7.10559 20.9679 7.32915 21.087 7.61264C21.1911 7.86039 21.1911 8.13961 21.087 8.38737C20.9679 8.67086 20.624 8.89441 19.9361 9.34152L13.744 13.3664C13.1127 13.7767 12.7971 13.9819 12.457 14.0617C12.1564 14.1323 11.8436 14.1323 11.543 14.0617C11.2029 13.9819 10.8873 13.7767 10.256 13.3664L4.06386 9.34151C3.37601 8.89441 3.03209 8.67086 2.91297 8.38737C2.80888 8.13961 2.80888 7.86039 2.91297 7.61264C3.03209 7.32915 3.37601 7.1056 4.06386 6.65849L10.256 2.63358M21.5 19L14.8572 13M9.14282 13L2.5 19"
      stroke="#2121217f"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</ng-template>
